<template>
	<div class="days_column" :class='{selected : this.selectclass}'  v-on-clickaway="away">
		

		<div class="top" :class="{'today' : isToday(day) }" >
			{{ displayDay(day, row) }} <span>{{ displayDayNum(day, row) }}</span>
		</div>

		<div class="cell_see_more" v-if='displayDayEvents(day).length > 5' @click='toggleSeeMore' >
			<span v-if="seeMoreToggle">See less</span>
			<span v-else>See more</span>
		</div>

		<ul class="event_list" :class='{seeMore: displayDayEvents(day).length > 5, expand : seeMoreToggle== true}' >

			<li v-for='event in displayDayEvents(day)'>

				<OneEvent :event='event' :showTime='false' v-on:eventchild='childenClicked'></OneEvent>

			</li>

		</ul>

	</div> 

</template>


<script>
	import { directive as onClickaway } from 'vue-clickaway';
	import store  from './CalendarStoreEvents'
	import moment from 'moment'
	import OneEvent from './OneEvent'
	
	export default {
	  	name: 'day-cell',
	  	props: ['day', 'row'], 
	  	data () {
		    return {
		    	date: null, 
		    	state: store.state, 
		    	seeMoreToggle: false, 
		    	selectclass: false
		    }
		}, 
		  directives: {
		    onClickaway: onClickaway,
		  },
	
		components : { OneEvent }, 
		methods : {

			toggleSeeMore(){
				this.seeMoreToggle = !this.seeMoreToggle
			},

			isToday(date){
			
				if( moment(date).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')){
					return true
				} 
			},


			displayDay(date, row){
				let dayNum =  moment(date).format('DD'); 
			
				if(row == 0){	
					return moment(date).format('ddd'); 	
				}
				
			}, 

			displayDayNum(date, row){
				let dayNum =  moment(date).format('DD'); 
			

				if(row == 0 && dayNum <= 7){	
					return dayNum
				}

				if(row > 0 && row < 4){	
					return dayNum
				}

				if(row == 4 && dayNum > 20){	
					return dayNum
				}	
				
			}, 


			displayDayEvents(date){	
			 	
				return store.filterByDaySingle(this.state.events, date)

			}, 


			childenClicked: function(id) {
				
				this.selectclass = id
			},
			away(){
				this.selectclass = false
			
			},

		}
		
	}

</script>


// WEBPACK FOOTER //
// DayCell.vue?5d4ea390